import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_PSF_PROMOTE_OR_SHARE_SHARE_SLIDE_UP_ENABLED = createFcmDetails(
	'psf_promote_or_share_share_slide_up_enabled',
	{
		owner: 'Supporter Experience Squad',
		context: 'PSF Promote or Share page',
		description: 'Enables the share slide up on the PSF Promote or Share page in mobile devices.',
		import: false,
	},
);
